import React from "react";
import { useLocation } from "react-router-dom";
import commonHeaderBg from '../../../assets/images/backgrounds/commonHeaderBg.webp';

function CommonHeader() {
  const location = useLocation();

  const path = location.pathname.split("/").filter(Boolean);
  const pageName = path[path.length - 1] || "Home";

  const formattedPageName = pageName
  .split("-")
  .map(word => word.charAt(0).toUpperCase() + word.slice(1))
  .join(" ");

  return (
    <div
      className="relative w-full h-20 md:h-28 flex items-center justify-center bg-cover bg-center"
      style={{ backgroundImage: `url(${commonHeaderBg})` }}
    >
      <div className="relative text-center">
        <h1 className="text-2xl md:text-4xl font-outfitSemiBold">
          {formattedPageName}
        </h1>
        {/* <p className="md:text-sm text-xs mt-2 tracking-wide bg-white shadow-xl py-1 px-4">
          HOME / {formattedPageName.toUpperCase()}
        </p> */}
      </div>
    </div>
  );
}

export default CommonHeader;
